import React from "react";
function Comment() {
  return (
    <div id="bot-scene-container" className="">
      <div id="bot-scene-content" className="scroll-light">
        <div className="app-v3-conversation--comments--container">
          <div className="app-v3-conversation--comments--header">
            <div className="app-v3-conversation--comments--header--title">
              Bình luận
            </div>
            <div className="app-v3-conversation--comments--header--action">
              <button
                disabled
                type="button"
                className="app-btn app-btn-default app-v3-btn--h-36 app-v3-conversation--comments--header--actions--cancel"
              >
                Hủy
              </button>
              <button
                type="button"
                className="app-btn app-btn-primary app-btn-action app-v3-btn--h-36 app-v3-conversation--comments--header--actions--save"
              >
                <svg width="16" height="16" fill="none" viewBox="0 0 16 16">
                  <path
                    fill="#fff"
                    fillRule="evenodd"
                    d="M11.727 2.393A1.338 1.338 0 0010.78 2H3.333C2.593 2 2 2.6 2 3.333v9.334C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667V5.22c0-.353-.14-.693-.393-.94l-1.88-1.887zM8 12.667c-1.107 0-2-.894-2-2 0-1.107.893-2 2-2s2 .893 2 2c0 1.106-.893 2-2 2zM4.667 6h4C9.4 6 10 5.4 10 4.667c0-.734-.6-1.334-1.333-1.334h-4c-.734 0-1.334.6-1.334 1.334C3.333 5.4 3.933 6 4.667 6z"
                    clipRule="evenodd"
                  />
                </svg>
                <span>Lưu</span>
              </button>
            </div>
          </div>
          <div className="app-v3-conversation--commnets--body">
            <div className="app-v3-conversation--comments--body--wrapper">
              <div className="app-v3-conversation--comments--item">
                <div className="app-v3-conversation--comments--item--content">
                  <div className="app-v3-conversation--comments--item--content__title">
                    Tự động ẩn tất cả bình luận
                  </div>
                  <div className="app-v3-conversation--comments--item--content__desc">
                    Hệ thống sẽ tự động ẩn tất cả bình luận của khách hàng với
                    tất cả các bài viết trên Page của bạn.
                  </div>
                </div>
                <div className="app-v3-conversation--comments--item--action">
                  <button type="button" className="app-switch">
                    <span className="app-switch-inner"></span>
                    <div className="app-click-animating-node"></div>
                  </button>
                </div>
              </div>
              <div className="app-v3-conversation--comments--item">
                <div className="app-v3-conversation--comments--item--content">
                  <div className="app-v3-conversation--comments--item--content__title">
                    Tự động ẩn tất cả bình luận có số điện thoại
                  </div>
                  <div className="app-v3-conversation--comments--item--content__desc">
                    Hệ thống sẽ tự động ẩn tất cả bình luận có số điện thoại của
                    khách hàng với tất cả các bài viết trên Page của bạn.
                  </div>
                </div>
                <div className="app-v3-conversation--comments--item--action">
                  <button type="button" className="app-switch">
                    <span className="app-switch-inner"></span>
                    <div className="app-click-animating-node"></div>
                  </button>
                </div>
              </div>
              <div className="app-v3-conversation--comments--keywords">
                <div className="app-v3-conversation--comments--item">
                  <div className="app-v3-conversation--comments--item--content">
                    <div className="app-v3-conversation--comments--item--content__title">
                      Ẩn bình luận có từ khóa
                    </div>
                    <div className="app-v3-conversation--comments--item--content__desc">
                      Hệ thống sẽ tự động ẩn tất cả bình luận có từ khoá của
                      khách hàng với tất cả các bài viết trên Page của bạn.
                    </div>
                  </div>
                  <div className="app-v3-conversation--comments--item--action">
                    <button type="button" className="app-switch">
                      <span className="app-switch-inner"></span>
                      <div className="app-click-animating-node"></div>
                    </button>
                  </div>
                </div>
                <div className="app-v3-conversation--comments--keywords--box">
                  <div className="app-input-keyword--container">
                    <div className="app-input-keyword--box">
                      <div>
                        <ul className="app-input-keyword--list">
                          <li className="app-input-keyword--item app-input-keyword--item-input-addtags">
                            <input
                              className="app-v3-conversation--comments--input-keywords"
                              placeholder="Nhập từ khoá"
                              defaultValue=""
                            />
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Comment;
